/**
 *
 * RightSidebar
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { StyledRightSidebar } from './styledComponents';
import LiveNewsSidebar from '../LiveNewsSidebar/LiveNewsSidebar.component';
import SponsorsSidebar from '../SponsorsSidebar/SponsorsSidebar.component';
import CollapseButtonLine from '../CollapseButtonLine/CollapseButtonLine.component';
import { useQueryParams } from 'use-query-params';
import { AppQueryParamsConfigMap } from '../../app/constants';
import { useEventAds } from '../../api/useEventAds';
import { useEventNews } from '../../api/useEventNews';

interface IProps {}

const RightSidebar: FunctionComponent<IProps> = () => {
  const [expanded, setExpanded] = useState(true);
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const { data: sponsors } = useEventAds(query.e);
  const { data: news } = useEventNews(query.e);

  if (!sponsors?.length && !news?.length) {
    return null;
  }
  return (
    <StyledRightSidebar style={{ flex: expanded ? '0 1 250px' : '0 0 62px' }}>
      <CollapseButtonLine
        onClick={() => setExpanded(!expanded)}
        position="left"
        expanded={expanded}
      />
      <LiveNewsSidebar expanded={expanded} />
      <SponsorsSidebar expanded={expanded} />
    </StyledRightSidebar>
  );
};

export default memo(RightSidebar);
